module.exports = __webpack_public_path__ + "img/badge_color_hs-military.3aafeffb.svg";